import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { ReactSortable } from 'react-sortablejs';
import OrdsifjabokView from './OrdsifjabokView.js';
import BlondalView from './BlondalView.js';
import RitmalssafnView from './RitmalssafnView.js';
import BinViewV2 from './BinViewV2.js';
import KataView from './KataView.js';
import OrdanetView from './OrdanetView.js';
import MalfarView from './MalfarView.js';
import StafsetningView from './StafsetningView.js';
import OrdabankiView from './OrdabankiView.js';
import IslexView from './IslexView.js';
import NyyrdiView from './NyyrdiView.js';
import RussneskaView from './RussneskaView.js';
import ONPView from './ONPView.js'

import _ from 'underscore';

import config from './../config';
import helpers from './../helpers';

import { SortingContext } from "./SortingContext";

class Suggestions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: []
		}
	}

	fetchData(searchString) {
		fetch(config.apiRoot+'othekkt/'+searchString)
			.then(function(response) {
				return response.json();
			})
			.then((json) => {
				this.setState({
					data: json[0].othekktlisti.flettur
				});
			});
	}

	componentDidMount() {
		if (this.props.searchString) {
			this.fetchData(this.props.searchString);
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.searchString !== prevProps.searchString) {
			this.fetchData(this.props.searchString);
		}
	}

	render() {
		return this.state.data.length > 0 ? <React.Fragment><hr style={{margin: 0}}/><div className="card-body text-center">Áttir þú við {
			this.state.data.map((item, index) => {
				return <React.Fragment key={index}>
					{
						index > 0 && index === this.state.data.length-1 &&
						<React.Fragment> eða </React.Fragment>
					}
					{
						index > 0 && index < this.state.data.length-1 && this.state.data.length > 1 &&
						<React.Fragment>, </React.Fragment>
					}
					<Link to={'/leit/'+item}>{item}</Link>
				</React.Fragment>
			})
		}?</div></React.Fragment> : null
	}
}

// function Aprilgabb() {
// 	const [init, setInit] = useState(false);

// 	useEffect(() => {
// 		setTimeout(() => setInit(true), 1000);
// 	}, []);

// 	return <div className="card initialized" style={{
// 		background: 'rgb(93,104,0)',
// 		background: 'linear-gradient(31deg, rgba(93,104,0,1) 0%, rgba(0,104,65,1) 100%)',
// 		color: 'white',
// 		padding: '40px',
// 		textAlign: 'center',
// 		margin: '20px 0 40px 0',
// 		opacity: init ? 1 : 0,
// 		transform: init ? 'scale(1) rotate(-1.5deg)' : 'scale(0.9) rotate(0deg)',
// 		transition: 'all 1000ms ease-in-out'
// 	}}>
// 		<div style={{
// 			fontSize: '30px',
// 			fontWeight: 'bold',
// 			marginBottom: '20px'
// 		}}>Þú hefur hlaupið 1. apríl!</div>
// 		<div style={{
// 			fontSize: '18px'
// 		}}>Árnastofnun ætlar ekki að eyða orðum úr gagnasöfnum sínum. Þvert á móti leggjum við kapp á að halda utan um orðaforða íslenskunnar, jafnt orð sem eru í stöðugri notkun en einnig eldri og sjaldgæfari orð sem finna má í hinum fjölmörgu orðasöfnum okkar.</div>
// 	</div>
// }

class SearchResultsList extends Component {
	constructor(props) {
		super(props); 

		/*
		this.foolWords = [
			'aðhneiging',
			'drymbildrútur',
			'dugandlegur',
			'glatarí',
			'hnóhnika',
			'jarðvarp',
			'lýðskyldur',
			'mótorhjólhestur',
			'nítugur',
			'nýsmánlegur',
			'rampóneraður',
			'reiknishaldari',
			'röskvi',
			'skýjablesi',
			'slauksamur',
			'svíri',
			'tísaldalegur',
			'tísaldarlegur',
			'traðjóla',
			'veðurkápa',
		]
		*/

		this.initialState = {
			searchResults: {},
			fetching: true,
			initialized: false,
			enableSorting: {
				flokkur1: false,
				flokkur3: false,
				flokkur2: false
			},
			selectedTab: localStorage.getItem(this.localStorageKey+'_tab') ? localStorage.getItem(this.localStorageKey+'_tab') : 'flokkur1',
			isSortingMode: false,
			resultCollectionCount: {
				total: -1,
				flokkur1: 0,
				flokkur3: 0,
				flokkur2: 0
			}
		};

		this.url = config.apiRoot;

		this.searchResultsLinkHandler = this.searchResultsLinkHandler.bind(this);

		// this.initialState.sorting = localStorage.getItem(this.localStorageKey) ? JSON.parse(localStorage.getItem(this.localStorageKey)) : this.dataCategories;
		let savedSorting = localStorage.getItem(this.localStorageKey)
		? JSON.parse(localStorage.getItem(this.localStorageKey))
		: null;

		if (savedSorting) {
		savedSorting = this.confirmSortingData(savedSorting);
		} else {
		savedSorting = this.dataCategories;
		}
		this.initialState.sorting = savedSorting;
		this.state = this.initialState;
	}

	initialState = {}

	localStorageKey = 'malid_sorting_v3.4'

	confirmSortingData(sortingData) {
		try {
			for (let key in sortingData) {
				this.dataCategories[key].forEach((item, i) => {
					if (_.filter(sortingData[key], (sortingItem) => item.id === sortingItem.id).length === 0) {
						sortingData[key].push(item);
					}
				});
			}
		}
		catch (e) {

		}
		return sortingData;
	}

	dataCategories = {
		'flokkur1': [
			{
				id: 'kata'
			},
			{
				id: 'bin_malid2'
			},
			{
				id: 'stafsetning'
			},
			{
				id: 'ordanet'
			},
			{
				id: 'malfar'
			},
			{
				id: 'ordabanki'
			},
			{
				id: 'nyyrdi'
			}
		],
		'flokkur3': [
			{
				id: 'danska'
			},
			{
				id: 'saenska'
			},
			{
				id: 'norska'
			},
			{
				id: 'nynorsk'
			},
			{
				id: 'finnska'
			},
			{
				id: 'faereyska'
			},
			{
				id: 'franska'
			},
			{
				id: 'thyska'
			},
			{
				id: 'polska'
			},
			{
				id: 'enska'
			}
		],
		'flokkur2': [
			{
				id: 'blondal'
			},
			{
				id: 'ritmalssafn'
			},
			{
				id: 'ordsifjabok'
			},
			{
				id: 'russneska'
			},
			{
				id: 'onp'
			}
		]
	}

	componentDidMount() {
		if (this.props.match.params.searchString) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// Skoðað hvort breytur hafa breyst og hvort component eigi að uppfærast
		if (
			prevProps.match.params.searchString !== this.props.match.params.searchString
		) {
			this.fetchData();
		}
	}

	componentDidCatch(error, errorInfo) {
		setTimeout(() => {
			window.localStorage.clear();

			this.initialState.sorting = this.dataCategories;

			this.setState(this.initialState);

			if (window.location.hash !== '#v') {
				window.location.hash = 'v';
				window.location.reload();
			}
		}, 500);
	}

	searchResultsLinkHandler(link) {
		//this.props.history.push('/leit/'+this.props.match.params.searchString+'/link/?link='+link);

		window.location.href = link;
	}

	getResultCollectionsCount(data) {
		let count = {
			total: 0,
			flokkur1: 0,
			flokkur3: 0,
			flokkur2: 0
		};

		try {
			for (let key in data) {
				if (data[key] && data[key].length > 0) {
					if (_.find(this.dataCategories.flokkur1, (item) => item.id === key)) {
						count.total++;
						count.flokkur1++;
					}

					if (_.find(this.dataCategories.flokkur2, (item) => item.id === key)) {
						count.total++;
						count.flokkur2++;
					}

					if (_.find(this.dataCategories.flokkur3, (item) => item.id === key)) {
						count.total++;
						count.flokkur3++;
					}
				}
			}
		}
		catch (e) {}

		count.total = count.total === 0 ? -1 : count.total;

		return count;
	}

	fetchData() {
		window.scrollTo(0, 0);

		let searchString = this.props.match.params.searchString

		// Sæki gögn til APA
		this.setState({
			fetching: true,
			initialized: false,
			enableSorting: this.initialState.enableSorting,
			searchResults: searchString.indexOf('*') > -1 || searchString.indexOf('_') > -1 ? [] : this.state.searchResults
		}, function() {
			for (let item in this.state.enableSorting) {
				if (this.state.enableSorting[item] && this.refs['sortable_'+item] && this.refs['sortable_'+item].sortable) {
					this.refs['sortable_'+item].sortable.options.disabled = true;
				}
			}
		}.bind(this));

		searchString = searchString.split('*').join('$').split('_').join('€');

		fetch(this.url+searchString)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				if (!json.malid && Array.isArray(json)) {
					this.setState({
						searchResults: json,
						resultsType: 'list',
						fetching: false
					}, () => {
						this.setState({
							initialized: true
						});
					});
				}
				else {
					let resultCollectionCount = this.getResultCollectionsCount(json.malid);

					this.setState({
						searchResults: json.malid,
						resultCollectionCount: resultCollectionCount,
						resultsType: 'results',
						fetching: false,
						selectedTab: resultCollectionCount[this.state.selectedTab] > 0 ? this.state.selectedTab : resultCollectionCount['flokkur1'] > 0 ? 'flokkur1' : resultCollectionCount['flokkur2'] > 0 ? 'flokkur2' : 'flokkur3'
					}, () => {
						localStorage.setItem(this.localStorageKey+'_tab', this.state.selectedTab);
						this.setState({
							initialized: true
						});
					})

					if (this.props.onSearch) {
						this.props.onSearch({
							searchString: this.props.match.params.searchString
						});
					}

				}
			}.bind(this));
	}

	render() {
		const isAnySortingEnabled = Object.values(this.state.enableSorting).some(Boolean);
		if (this.state.resultsType === 'list') {
			return <div className={'search-results container'}>
				<div className="col-md-8 offset-md-2 main">
					{
						this.state.searchResults.length === 0 &&
						<div key="notfound" className={'card '+(this.state.initialized ? ' initialized' : '')}>
							<div className={'card-body text-center'}>
								{window.l('notfount_part1')} <strong>{this.props.match.params.searchString}</strong> {window.l('notfount_part2')}
							</div>
						</div>
					}
					{
						this.state.searchResults.length > 0 &&
						<React.Fragment>
							<div className={'card '+(this.state.initialized ? ' initialized' : '')}>
								<div className="card-body text-center">
									<strong>{this.state.searchResults.length}</strong> {helpers.plural('fletta fannst', 'flettur fundust', this.state.searchResults.length)}{this.state.searchResults.length > 20 ? ', fyrstu 20 eru sýndar' : ''}
								</div>
							</div>

							<div className={'card '+(this.state.initialized ? ' initialized' : '')}>

								<div className="list-group">
									{
										this.state.searchResults.slice(0, 20).map((fletta, index) => <div className="list-group-item item">
											<Link className="text-light" to={'/leit/'+fletta.fletta} key={index}>{fletta.fletta}</Link>
											<br/>
											<small>{fletta.sofn}</small>
										</div>)
									}
								</div>

							</div>
						</React.Fragment>
					}
				</div>
			</div>;
		}
		else {
			let count = 0;

			let getCount = function() {
				count++;
				return count;
			}

			let getResultCount = (category) => this.dataCategories[category].map((item) => {
				try {
					return this.state.searchResults[item.id].length;
				}
				catch (e) {
					return 0;
				}
			}).reduce((s, f) => {
				return s + f;
			}, 0);

			let resultsList = [
				{
					category: 'flokkur1',
					label: window.l('flokkur1_label'),
					list: {
						kata: <KataView
							key="kata"
							onLink={this.searchResultsLinkHandler}
							data={this.state.searchResults.kata}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						bin_malid2: <BinViewV2
							key="bin_malid2"
							onLink={this.searchResultsLinkHandler}
							data={this.state.searchResults.bin_malid2}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						stafsetning: <StafsetningView
							key="stafsetning"
							data={this.state.searchResults.stafsetning}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						ordanet: <OrdanetView
							key="ordanet"
							onLink={this.searchResultsLinkHandler}
							data={this.state.searchResults.ordanet}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						malfar: <MalfarView
							key="malfar"
							onLink={this.searchResultsLinkHandler}
							data={this.state.searchResults.malfar}
							count={getCount()} frontPage={this.props.frontPage} />,
						ordabanki: <OrdabankiView
							key="ordabanki"
							data={this.state.searchResults.ordabanki}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						nyyrdi: <NyyrdiView
							key="nyyrdi"
							data={this.state.searchResults.nyyrdi}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
					},
					resultsCount: getResultCount('flokkur1')
				},
				{
					category: 'flokkur3',
					label: window.l('flokkur3_label'),
					list: {
						danska: <IslexView
							key="danska"
							title="Íslensk-dönsk orðabók"
							subTitle={window.l('islex_title')}
							lang="DA"
							data={this.state.searchResults.danska}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						saenska: <IslexView
							key="saenska"
							title="Íslensk-sænsk orðabók"
							subTitle={window.l('islex_title')}
							lang="SE"
							data={this.state.searchResults.saenska}
							count={getCount()}
							frontPage={this.props.frontPage}
							hideOnFrontPage={true}
						/>,
						norska: <IslexView
							key="norska"
							title="Íslensk-norsk orðabók"
							subTitle={window.l('islex_title')}
							lang="NO-B"
							data={this.state.searchResults.norska}
							count={getCount()}
							frontPage={this.props.frontPage}
							hideOnFrontPage={true}
						/>,
						nynorsk: <IslexView
							key="nynorsk"
							title="Íslensk-nýnorsk orðabók"
							subTitle={window.l('islex_title')}
							lang="NO-N"
							data={this.state.searchResults.nynorsk}
							count={getCount()}
							frontPage={this.props.frontPage}
							hideOnFrontPage={true}
						/>,
						finnska: <IslexView
							key="finnska"
							title="Íslensk-finnsk orðabók"
							subTitle={window.l('islex_title')}
							lang="FI"
							data={this.state.searchResults.finnska}
							count={getCount()}
							frontPage={this.props.frontPage}
							hideOnFrontPage={true}
						/>,
						faereyska: <IslexView
							key="faereyska"
							title="Íslensk-færeysk orðabók"
							subTitle={window.l('islex_title')}
							lang="FO"
							data={this.state.searchResults.faereyska}
							count={getCount()}
							frontPage={this.props.frontPage}
							hideOnFrontPage={true}
						/>,
						franska: <IslexView
							key="franska"
							title="Íslensk-frönsk orðabók"
							subTitle="LEXÍA"
							aboutText={window.l('lexia_about')}
							url="http://lexia.arnastofnun.is"
							lang="FRA"
							data={this.state.searchResults.franska}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						thyska: <IslexView
							key="thyska"
							title="Íslensk-þýsk orðabók"
							subTitle="LEXÍA"
							aboutText={window.l('lexia_about')}
							lang="TYS"
							url="http://lexia.arnastofnun.is"
							hideUrl={false}
							data={this.state.searchResults.thyska}
							count={getCount()}
							frontPage={this.props.frontPage}
							hideOnFrontPage={true}
						/>,
						polska: <IslexView
							key="polska"
							title="Íslensk-pólsk orðabók"
							subTitle={'Íslensk-pólsk orðabók'}
							aboutText={window.l('polsk_about')}
							lang="POL"
							url={'https://pl.is'}
							data={this.state.searchResults.polska}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						enska: <IslexView
							key="enska"
							title="Íslensk-ensk orðabók"
							subTitle={'Íslensk-ensk orðabók'}
							aboutText={window.l('ensk_about')}
							lang="EN"
							url={'https://enska.arnastofnun.is'}
							data={this.state.searchResults.enska}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>
					},
					resultsCount: getResultCount('flokkur3')
				},
				{
					category: 'flokkur2',
					label: window.l('flokkur2_label'),
					list: {
						blondal: <BlondalView
							key="blondal"
							data={this.state.searchResults.blondal}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						ritmalssafn: <RitmalssafnView
							key="ritmalssafn"
							data={this.state.searchResults.ritmalssafn}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						ordsifjabok: <OrdsifjabokView
							key="ordsifjabok"
							data={this.state.searchResults.ordsifjabok}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						russneska: <RussneskaView
							key="russneska"
							data={this.state.searchResults.russneska}
							count={getCount()}
							frontPage={this.props.frontPage}
						/>,
						onp: 
							<ONPView
								data={this.state.searchResults.onp}
								count={getCount()}
								key="onp"
								frontPage={this.props.frontPage}
							/>
					},
					resultsCount: getResultCount('flokkur2')
				}
			];

			return (
				<div className={'search-results container'+(this.props.frontPage ? ' front' : ' results')+(this.state.enableSorting[this.state.selectedTab] ? ' enable-sorting' : '')+(this.state.fetching ? ' loading' : '')}>
					<div className="col-md-8 offset-md-2 main">
						{/*<LoadingBar />*/}
						{
							(this.state.resultCollectionCount.total > 0) &&
							<div className="search-toolbar">
								{
									(this.state.searchResults && this.props.match.params.searchString) &&
									<React.Fragment>
										<span className="search-message">
											<strong>{this.props.match.params.searchString}</strong> {window.l('found_part1')} {this.state.resultCollectionCount.total} {this.state.resultCollectionCount.total === 1 ? window.l('found_part2') : window.l('found_part2_plural')}
										</span>
									</React.Fragment>
								}
								<button
									className="sort-button"
									onClick={() => {
										let enableSorting = { ...this.state.enableSorting };

										enableSorting[this.state.selectedTab] = !enableSorting[this.state.selectedTab];

										this.setState({
											enableSorting,
											isSortingMode: true
										});

										this.refs['sortable_' + this.state.selectedTab].sortable.options.disabled =
										!enableSorting[this.state.selectedTab];

										this.setState({ enableSorting });
									}}
									>
									<span>{window.l('rada_gagnasofnum')}</span>
								</button>
							</div>
						}

						{
							this.state.searchResults.beygingar && this.state.searchResults.beygingar.length > 0 && this.state.searchResults.beygingar[0].flettur && this.state.searchResults.beygingar[0].flettur && this.state.searchResults.beygingar[0].flettur.length > 0 && !this.state.fetching &&
							(() => {
								let beygingar = _.flatten(this.state.searchResults.beygingar.map((item) => item.flettur));

								return <div className="card initialized">
									<div className="card-body text-center">
										<strong>{this.state.searchResults.beygingar[0].beygingarmynd.toLowerCase()}</strong> getur líka verið beygingarmynd af {
											beygingar.map((item, flIndex) => {
												return <React.Fragment key={flIndex}>
													{
														flIndex > 0 && flIndex === beygingar.length-1 &&
														<React.Fragment> og </React.Fragment>
													}
													{
														flIndex > 0 && flIndex < beygingar.length-1 && beygingar.length > 1 &&
														<React.Fragment>, </React.Fragment>
													}
													<Link to={'/leit/'+item.lemma}>{item.lemma}</Link> <em>{item.kennimyndir ? item.kennimyndir+' ' : ''}</em>({item.ofl})
												</React.Fragment>
											})
										}
									</div>
								</div>
							})()
						}

						{
							this.state.resultCollectionCount.total <= 0 && !this.props.frontPage && /*(this.state.searchResults.beygingar && this.state.searchResults.beygingar.length == 0) &&*/
							<div key="notfound" className={'card '+(this.state.initialized ? ' initialized' : '')}>
								<div className={'card-body text-center'}>
									{window.l('notfount_part1')} <strong>{this.props.match.params.searchString}</strong> {window.l('notfount_part2')}
								</div>
								{
									this.state.searchResults.beygingar && this.state.searchResults.beygingar.length === 0 &&
									<Suggestions searchString={this.props.match.params.searchString} />
								}
							</div>
						}

						<p className={'text-message sort-message'+(this.state.enableSorting[this.state.selectedTab] ? ' visible' : '')}>{window.l('rada_gagnasofnum_info')}<br/>
							<img className="menu-link-back-arrow smaller-arrow" alt="Go back" src="/img/back-icon-red.png"></img>
							<a href="#" onClick={function(event) {
								event.preventDefault();

								let enableSorting = this.state.enableSorting;
								enableSorting[this.state.selectedTab] = false;
								Object.keys(enableSorting).forEach((key) => enableSorting[key] = false); 

								this.setState({
									enableSorting: enableSorting,
									isSortingMode: false,
								}, function() {
									for (let item in this.state.enableSorting) {
										if (this.refs['sortable_'+item] && this.refs['sortable_'+item].sortable) {
											this.refs['sortable_'+item].sortable.options.disabled = true;
										}
									}
								}.bind(this));
							}.bind(this)}>{window.l('rada_gagnasofnum_lokid')}</a>.
						</p>

						{
							//this.props.match.params.searchString && this.foolWords.indexOf(this.props.match.params.searchString.toLowerCase()) > -1 && !this.props.frontPage && <Aprilgabb />
						}

						<div className="result-tabs">
							<div className="tabs">
								{
									!this.props.frontPage && resultsList.filter((item) => item.resultsCount > 0).map((resultItem, index) =>
										<button key={index}  className={'tab'+(this.state.selectedTab === resultItem.category ? ' selected' : '')} onClick={() => {
											let enableSorting = { ...this.state.enableSorting };

											if (this.state.isSortingMode) {
												enableSorting[resultItem.category] = true;
											}

											this.setState({
												selectedTab: resultItem.category,
												enableSorting
											});

											localStorage.setItem(this.localStorageKey + "_tab", resultItem.category);
											}}>{resultItem.label+' ('+this.state.resultCollectionCount[resultItem.category]+')'}</button>
									)
								}
								{
									this.props.frontPage && resultsList.map((resultItem, index) =>
										<button key={index} disabled={this.state.enableSorting[this.state.selectedTab]} className={'tab'+(this.state.selectedTab === resultItem.category ? ' selected' : '')} onClick={() => {
											this.setState({
												selectedTab: resultItem.category
											});
											localStorage.setItem(this.localStorageKey+'_tab', resultItem.category);
										}}>{resultItem.label}</button>
									)
								}
							</div>
							{
							resultsList.filter((item) => item.category === this.state.selectedTab).map((resultItem, index) => (
									<div key={index} className="tab-content selected">
									{this.props.frontPage && false && (
										<h2 className="tab-title">
										<span>{resultItem.label}</span>
										</h2>
									)}

									<SortingContext.Provider value={isAnySortingEnabled}>
										<ReactSortable
										list={this.state.sorting[resultItem.category]}
										ref={"sortable_" + resultItem.category}
										disabled={!this.state.enableSorting[resultItem.category]}
										forceFallback={navigator.userAgent.toLowerCase().includes("firefox")}
										setList={(newSorting) => {
											const sorting = { ...this.state.sorting };
											sorting[resultItem.category] = newSorting;

											this.setState({ sorting }, () => {
											localStorage.setItem(this.localStorageKey, JSON.stringify(sorting));
											});
										}}
										>
										{this.state.sorting[resultItem.category].map((item) => {
											return resultItem.list[item.id];
										})}
										</ReactSortable>
									</SortingContext.Provider>
									</div>
								))}
						</div>

					</div>

					{
						(() => {
							try {
								if (btoa(this.props.match.params.searchString.toLowerCase()) === 'aG51YmJ1cg==') {
									return <div style={{
										position: 'fixed',
										bottom: 20,
										right: 20
									}} dangerouslySetInnerHTML={{__html: atob('PGltZyBzcmM9Imh0dHBzOi8vdXBsb2FkLndpa2ltZWRpYS5vcmcvd2lraXBlZGlhL2NvbW1vbnMvMi8yOS9LbGlwZGFzLmpwZz8xNjM2NTUyOTIyNzc5IiBzdHlsZT0ibWF4LXdpZHRoOiAxMzBweDsgbWF4LWhlaWdodDogMTMwcHg7Ij4=')}} />
								}
							}
							catch(e) {
								return null;
							}
						})()
					}

				</div>
			);
		}
	}
}

export default withRouter(SearchResultsList);



// WEBPACK FOOTER //
// ./src/components/SearchResultsList.js